import React, { useEffect } from "react";
import DynamicViewTable from "./DynamicViewTable";
import Popup from "reactjs-popup";
import { marfatiyaApiConfig } from "../config/apiConfig.js";
import { 
  groupInfo, 
  dataObject, 
  popupInfo, 
  validate,
  challanBiltyOriginalTableHeader, 
  challanBiltyOriginalTableItems
} from "../config/MarfatiyaConfig.js";
import { SERVER_URL } from "../config/config";
import { Prompt } from "react-router-dom";
import Autosuggest from "react-autosuggest";
import "./Form.css";
import "./TripForm.css";
import "./AutoSuggest.css";
import useForm from "./useForm";
import "./popup.css";
import DatePicker from "react-datepicker";
import FormColumn from "./FormColumn.js";
import print from "print-js";
import { useLocation } from "react-router-dom";

const MarfatiyaForm = ({ sessionObject }) => {
  const location = useLocation();
  let variablesFromSession = {
    station_from: String(sessionObject.sessionVariables.branch_id),
    station_from_name: sessionObject.sessionVariables.branch_name,
    created_from: String(sessionObject.sessionVariables.branch_id),
    created_by: String(sessionObject.sessionVariables.user_id),
    // login_user_id: String(sessionObject.sessionVariables.user_id),
    // role_id: String(sessionObject.sessionVariables.role_id),
    company_id: sessionObject.sessionVariables.company_id ?? "1",
    fYear: sessionObject.sessionVariables.financial_year,
  };

  const myForm = useForm(
    "Marfatiya",
    validate,
    { ...dataObject, ...variablesFromSession },
    marfatiyaApiConfig
  );

  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  React.useEffect(() => {
    console.log('pagestate', myForm.pageState);
  });

  React.useEffect(() => {
    // console.log(myForm.pageState);
    const defaultTripNo = location.state ?? "";
    console.log(defaultTripNo);
    if (defaultTripNo != "") {
      myForm.setPageState((oldPageState) => ({
        ...oldPageState,
        trip_no: defaultTripNo,
      }));

      const fakeKey = { key: "Enter" };
      myForm.getPageOnKeyEnter(fakeKey, defaultTripNo);
    }
  }, []);

  const checkIfFieldAlreadyExists = (fieldKey, fieldValue, arrayToCheck) => {
    let dummyObject = {};
    for (let i = 0; i < arrayToCheck.length; i++) {
      dummyObject = arrayToCheck[i];
      if (fieldKey in dummyObject && dummyObject[fieldKey] == fieldValue) {
        return true;
      }
    }
    return false;
  };

  const checkVisibilityCondition = (fieldInfo) => {
    // console.log("field info", fieldInfo, myForm.pageState.role_id)
    
    return true;
    
  };

  const checkDisabledCondition = (fieldInfo) => {
    if (myForm.pageMode == "view") {
      return "disabled";
    } else if (
      myForm.pageMode == "edit" &&
      fieldInfo.name == "mf_date" &&
      myForm.pageState.role_id != 1
    ) {
      return "disabled";
    } else {
      return "";
    }
  };

  const getAdditionalInfoForSuggestionFetch = (fieldInfoObject) => {
    // if (fieldInfoObject.name == "vehicle_no"){
    //   return {"limit": "10"};
    // }
    let additionalInfoObject = {};
    if (fieldInfoObject.name == "station_from_name") {
      additionalInfoObject.is_branch = true;
      // additionalInfoObject.pay_type = myForm.pageState.pay_type;
      return additionalInfoObject;
    }
    return null;
  };

  const linkBilty = async (e) => {
    const fYear_fetch = myForm.pageState.fyear_get_bilty;
    if (myForm.pageState["Bilty No"] == "" && e.key == "Enter") {
      myForm.makeFocusOnParticularField("delivery_on");
      return;
    }
    if (e.key == "Enter") {
      let flag = 0;
      if (
        myForm.pageState.bilty_type == "c" ||
        myForm.pageState.bilty_type == "C"
      ) {
        flag = 1;
      }
      let suffix = myForm.pageState.suffix;
      if (suffix == "") {
        suffix = "null";
      }
      const url =
        SERVER_URL +
        "/biltyget_bilty_for_marfatiya?bilty_no=" +
        myForm.pageState["Bilty No"] +
        "&branch_id=" +
        myForm.pageState.created_from +
        "&fyear=" +
        myForm.pageState.fyear_get_bilty +
        "&companyId=" +
        myForm.pageState.company_id;
  
      const response = await fetch(url);

      if (!response.ok) {
        myForm.setPageState({
          ...myForm.pageState,
          ["Bilty No"]: "",
        });
        const temp_error = await response.json();
        if ("detail" in temp_error) {
          myForm.setPreviousPageMode(myForm.pageMode);
          myForm.setPageMode("error");
          myForm.setPopupError(String(temp_error.detail));
        } else {
          myForm.setPreviousPageMode(myForm.pageMode);
          myForm.setPageMode("error");
          myForm.setPopupError("Invalid Bilty");
        }
        return;
      }

      const temp_response = await response.json();
      console.log('sss', temp_response)

      let updatedPageState = { ...myForm.pageState };
      if (temp_response.no_of_package) {
        updatedPageState.total_pkgs = temp_response.no_of_package;
      }

      if (
        temp_response.bilty_id &&
        !(updatedPageState.bilty_ids || []).some(
          (bilty) => bilty.bilty_id === temp_response.bilty_id
        )
      ) {
        updatedPageState.bilty_ids = [
          ...(updatedPageState.bilty_ids || []),
          temp_response,
        ];
      }

      myForm.setPageState(updatedPageState);
      myForm.makeFocusOnParticularField("packages");
    }
  };

  const handleDelete = async () => {
    const url =
      SERVER_URL +
      "/marfatiya/?mf_id=" +
      myForm.pageState.mf_id
    const response = await fetch(url, { method: "DELETE" });
    if (!response.ok) {
      console.log("Not able to delete marfatiya");
      return;
    }
    const temp_response = await response.json();
    if (temp_response === true) {
      myForm.setPageState({ ...dataObject, ...variablesFromSession });
      myForm.setPageMode("write");
      window.location.reload();
      return;
    }
  };

  const otherLinkBilty = (e) => {
    if (e.key === "Enter") {
      myForm.setPageState((oldState) => {
        let packages = parseInt(oldState.packages) || 0;
  
        if (!packages) {
          myForm.setPreviousPageMode(myForm.pageMode);
          myForm.setPageMode("error");
          myForm.setPopupError("Packages field cannot be empty.");
          myForm.makeFocusOnParticularField("packages");

          return oldState;
        }
  
  
        let prevPkgs = parseInt(oldState.pkgs) || 0;
        let prevLeftPkgs = parseInt(oldState.left_pkgs) || 0;
        let total_pkgs = parseInt(oldState.total_pkgs) || 0;
  
        let newPkgs = prevPkgs + packages;
        let newLeftPkgs = prevLeftPkgs + (total_pkgs - packages);
  
        return {
          ...oldState,
          pkgs: String(newPkgs),
          left_pkgs: String(newLeftPkgs),
          ["Bilty No"]: "",
          suffix: "", 
          total_pkgs: "", 
          packages: "", 
        };
      });
  
      myForm.makeFocusOnParticularField("bilty_no");
    }
  };  

  useEffect(() => {
    if (Array.isArray(myForm.pageState.bilty_info) && myForm.pageState.bilty_info.length > 0) {
      const existingIds = new Set((myForm.pageState.bilty_ids || []).map(bilty => bilty.bilty_id));
      
      const newBilties = myForm.pageState.bilty_info
        .filter(bilty => !existingIds.has(bilty.bilty_id))
        .map(bilty => ({
          ...bilty,
          station_from: bilty.station_from_name, 
          station_to: bilty.station_to_name 
        }));
  
      if (newBilties.length > 0) {
        myForm.setPageState(prevState => ({
          ...prevState,
          bilty_ids: [...(prevState.bilty_ids || []), ...newBilties]
        }));
      }
    }
  }, [myForm.pageState.bilty_info]); 
  
  

  // let isBlocking = (myForm.pageState!=dataObject);
  return (
    <div className="challan-form-container">
      {/* <Prompt
        when={
          JSON.stringify(myForm.pageState) !=
          JSON.stringify({ ...dataObject, ...variablesFromSession })
        }
        message={
          (location) =>
            `There is some unsaved data are you sure you want to leave it? ${myForm.pageState["Vehicle No."]}, 2132, ${dataObject["Vehicle No."]}`
          // `Are you sure you want to go to ${location.pathname}`
        }
      /> */}
      <div>
        <Popup
          // trigger={<button className="button"> Open Modal </button>}
          open={myForm.pageMode == "submitted" || myForm.pageMode == "error"}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                {" "}
                {myForm.pageMode == "submitted" ? (
                  <div>{popupInfo.success_header}</div>
                ) : (
                  <div>{popupInfo.error_header}</div>
                )}
                <div>
                  <a className="pop-up-close btn" onClick={close}>
                    &times;
                  </a>
                </div>
              </div>
              {myForm.pageMode == "submitted" ? (
                <div className="pop-up-content">
                  {popupInfo.success_title}
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">
                        {popupInfo.field_label_success}
                      </div>
                      <div className="pop-up-field-value">
                        {myForm.pageState[popupInfo.field_name_success]}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="pop-up-content">
                  {popupInfo.error_title}
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">
                        {popupInfo.field_label_error}
                      </div>
                      <div className="pop-up-field-value">
                        {myForm.popupError}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    if (myForm.pageMode == "submitted") {
                      // sessionObject.saveSessionVariableByField("last_bilty_no", {"last_bilty_no":myForm.pageState.bilty_no})
                      myForm.setPageState({
                        ...dataObject,
                        ...variablesFromSession,
                      });
                      myForm.setPageMode("write");
                      window.location.reload();
                      close();
                    } else {
                      if (myForm.previousPageMode != "") {
                        myForm.setPageMode(myForm.previousPageMode);
                        myForm.setPreviousPageMode("");
                      } else {
                        myForm.setPageMode("write");
                      }
                      close();
                    }
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>

      <div className="form-header">Marfatiya</div>
      <div onSubmit={myForm.handleSubmit} className="form" noValidate>
        <div className="form-title">
          <div className="form-row">
            <label className="form-label">Marfatiya No:</label>
            <input
              className="form-input"
              type="text"
              name="mf_no"
              placeholder=""
              value={myForm.pageState.mf_no}
              onChange={myForm.handleChange}
              onBlur={() => {}}
              onKeyPress={(a) =>
                myForm.getPageOnKeyEnter(a, myForm.pageState.mf_no)
              }
              disabled={checkDisabledCondition({ name: "mf_no" })}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "mf_no")}
            />
            {myForm.internalValidationErrors["mf_no"] && (
              <p>{myForm.internalValidationErrors["mf_no"]}</p>
            )}
            {myForm.pageMode == "view" && (
              <>
                {checkVisibilityCondition({ name: "edit_button" }) && (
                  <button
                    onClick={() => {
                      myForm.setPageMode("edit");
                    }}
                  >
                    Edit
                  </button>
                )}
                <button
                  onClick={() => {
                    myForm.setPageState({
                      ...dataObject,
                      ...variablesFromSession,
                    });
                    window.location.reload();
                    myForm.setPageMode("write");
                  }}
                >
                  Clear
                </button>
              </>
            )}
          </div>
          <label className="chform-label">Bilty No:</label>
            <input
              className="chform-input"
              type="text"
              name="Bilty No"
              placeholder=""
              value={myForm.pageState["Bilty No"] || myForm.pageState.bilty_no }
              onChange={myForm.handleChange}
              //   onKeyPress={(a) => {
              //     if (a.key == "Enter") {
              //       myForm.makeFocusOnParticularField("suffix");
              //     }
              //   }}
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  // console.log("press", myForm.pageState["Bilty No"]);
                  if (myForm.pageState["Bilty No"]) {
                    myForm.getFyearsOnKeyEnter(
                      e,
                      "Bilty Inquiry",
                      myForm.pageState["Bilty No"]
                    );
                  } else {
                    myForm.makeFocusOnParticularField("driver_name");
                  }
                }
              }}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "bilty_no")}
            />
            <select
              className="chform-input "
              name="suffix"
              value={myForm.pageState.suffix}
              onChange={(e) => myForm.handleChangeForSelect(e, "suffix")}
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  e.preventDefault();
                  linkBilty(e);
                }
              }}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "suffix")}
            >
              {myForm.pageState.suffix_options.map((suff) => {
                return <option value={suff}> {suff} </option>;
              })}
            </select>
            <label className="chform-label">Total Packages:</label>
            <input
              className="chform-input"
              type="text"
              name="total_pkgs"
              placeholder=""
              value={myForm.pageState["total_pkgs"]}
              onChange={myForm.handleChange}
              onKeyPress={(a) => {
                if (a.key == "Enter") {
                  myForm.makeFocusOnParticularField("packages");
                }
              }}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "total_pkgs")}
            />
            <label className="chform-label">Packages:</label>
            <input
              className="chform-input"
              type="text"
              name="packages"
              placeholder=""
              value={myForm.pageState["packages"]}
              onChange={(e) => {
                const enteredPackages = Number(e.target.value) || 0; 
                const totalPackages = Number(myForm.pageState["total_pkgs"]) || 0; 
                const calculatedPackages = totalPackages - enteredPackages;
            
                myForm.setPageState((prevState) => {
                  let updatedBiltyIds = [...(prevState.bilty_ids || [])];
            
                  if (updatedBiltyIds.length > 0) {
                    updatedBiltyIds[updatedBiltyIds.length - 1] = {
                      ...updatedBiltyIds[updatedBiltyIds.length - 1],
                      packages: calculatedPackages,
                      actual_packages: enteredPackages,
                    };
                  }
            
                  return {
                    ...prevState,
                    packages: enteredPackages,  
                    actual_packages: enteredPackages,
                    bilty_ids: updatedBiltyIds,
                  };
                });
              }}
              // onKeyPress={(a) => {
              //   if (a.key == "Enter") {
              //     myForm.makeFocusOnParticularField("driver_name");
              //   }
              // }}
              onKeyPress={otherLinkBilty}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "packages")}
            />

          <div>
            <label className="form-label">Marfatiya Date:</label>
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={myForm.pageState.mf_date ? new Date(myForm.pageState.mf_date) : null}
              onChange={(date) =>
                myForm.setPageStateByField("mf_date", date)
              }
              ref={(a) => myForm.storeInputReferenceForSelect(a, "mf_date")}
              disabled={checkDisabledCondition({ name: "mf_date" })}
              // onKeyPress={(a) => {
              //   console.log("Here");
              //   if (a.key == "Enter") {
              //     myForm.makeFocusOnParticularField("consignor_name");
              //   }
              // }}
            />
          </div>
          <div className="form-row">
            <label className="form-last_bilty">Last Marfatiya No:</label>
            <label className="form-last_bilty">
              {myForm.pageState.last_mf_no}
            </label>
          </div>
        </div>
        <div className="table-container">
        <DynamicViewTable
          // checkBox={1}
          tableHeader={challanBiltyOriginalTableHeader}
          tableItems={challanBiltyOriginalTableItems}
          tableValues={myForm.pageState["bilty_ids"]}
          setPageStateByField={myForm.setPageStateByField}
          pageStateArray={myForm.pageState["bilty_ids"]}
          fieldMapping="bilty_ids"
        />
        </div>
        <div className="form-input-content-block-0">
          <div className="form-field-left">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-1"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
              title="Marfatiya"
            />
          </div>
          <div className="form-field-right">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-2"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
              title="Marfatiya"
            />
          </div>
        </div>

        <div className="form-footer">
          <button
            onClick={(e) => {
              myForm.setServerPrintNeeded(true);
              myForm.handleSubmit(e);
            }}
            type="button"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "print_button")}
            className="btn btn-primary"
          >
            Print
          </button>
          <button
            onClick={myForm.handleSubmit}
            type="button"
            className="btn btn-primary"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "save_button")}
          >
            Save
          </button>
          <button 
            onClick={handleDelete} 
            disabled={!myForm.pageState.mf_id}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarfatiyaForm;
